import { Grid, List, ListItem } from "@mui/material";
import { NavLink, useLocation } from "react-router-dom";
import HomeIcon from "./../Assests/Home.svg";
import CompareIcon from "./../Assests/compare.svg";
import Manufacturing from "./../Assests/manufecturing.svg";
import shiftnChangeover from "./../Assests/shift-changeover.svg";
import oeecpt from "./../Assests/oee-cpt.svg";
import SourcingIcon from "./../Assests/sourcing.svg";
import flowsIcon from "./../Assests/flowstab.svg";
import truckIcon from "./../Assests/Truck 02.svg";
import vectorIcon from "./../Assests/Vector.svg";
import dynconIcon from "./../Assests/dynamiccons.svg";
import demandIcon from "./../Assests/demandicon.svg";
import processingplantIcon from "./../Assests/processingplant.svg";
import packagingplantIcon from "./../Assests/packagingplant.svg";
import procurementIcon from "./../Assests/procurement.svg";
import viewIcon from "./../Assests/Viewicon.svg";
import ListSubheader from "@mui/material/ListSubheader";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import DraftsIcon from "@mui/icons-material/Drafts";
import SendIcon from "@mui/icons-material/Send";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import StarBorder from "@mui/icons-material/StarBorder";
// import ooecpt from "./../Assests/ooe-cpt.svg";

import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { API_BASE_URL, LONG_GETALLSCENARIOS_API } from "../Utils/Config";
import { getRequest } from "../Services/AxiosConfiguration";

const isActiveStyle = {
  textDecoration: "none",
  color: "#ffffff",
  background: "#0921b7",
  width: "100%",
  padding: "10px",
};
const deActiveStyle = {
  textDecoration: "none",
  color: "#000",
  background: "#Ffffff",
  width: "100%",
  padding: "10px",
};

function LongTermSidebar() {
  const selectedCategoryId = useSelector(
    (state: any) => state.InputDataReducers.selectedCategoryId
  );
  console.log(selectedCategoryId, "selectedCategoryId");

  const userData = useSelector(
    (state: any) => state.InputDataReducers.apiUserData
  );
  console.log(userData, "userData");

  const selectedFolderId = useSelector(
    (state: any) => state.InputDataReducers.selectedFolderId
  );

  const selectedScenarioId = useSelector(
    (state: any) => state.InputDataReducers.selectedScenarioId
  );
  console.log(selectedFolderId, "selectedFolderID");

  const [folderName, setFolderName] = useState<any>("");
  useEffect(() => {
    const urls = API_BASE_URL + LONG_GETALLSCENARIOS_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    getRequest(
      urls,
      { folder_id: selectedFolderId, createdBy: userData.userId },
      header
    )
      .then((response) => {
        if (response.status === 200 && response.data) {
          console.log(response.data, "responseseses");
          setFolderName(response.data[0]?.foldername);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [selectedFolderId]);

  localStorage.setItem("folderName", folderName?.slice(0, 7));

  const modified_FolderName = folderName?.slice(0, 7);

  console.log(modified_FolderName, "folderName");

  const sideMenuData = [
    {
      path: "/ltDemand",
      title: "Demand",
      subTitle: "Input",
      icon: shiftnChangeover,
    },
    {
      path: "/facilityMaster",
      title: "Facility Master",
      subTitle: "Input",
      icon: vectorIcon,
    },
    {
      path: "/cascadeMaster",
      title: "Cascade Master",
      subTitle: "Input",
      icon: vectorIcon,
    },
    {
      path: "/procurement",
      title: "RMPMMI Procurement",
      subTitle: "Input",
      icon: procurementIcon,
    },
    {
      path: "/rmTransportation",
      title: "RMPMMI Transportation",
      subTitle: "Input",
      icon: truckIcon,
    },
    {
      path: "/processingPlant",
      title: "Processing Plant",
      subTitle: "Input",
      icon: processingplantIcon,
    },
    {
      path: "/SFGTransportation",
      title: "SFG Transportation",
      subTitle: "Input",
      icon: truckIcon,
    },
    {
      path: "/packagingPlant",
      title: "Packaging Plant",
      subTitle: "Input",
      icon: packagingplantIcon,
    },
    {
      path: "/primaryTransportation",
      title: "Primary Transportation",
      subTitle: "Input",
      icon: truckIcon,
    },
    {
      path: "/sfgBOM",
      title: "SFG BOM",
      subTitle: "Input",
      icon: viewIcon,
    },
    {
      path: "/fgBOM",
      title: "FG BOM",
      subTitle: "Input",
      icon: viewIcon,
    },
  ];

  const sideMenuModule2 = [
    {
      path: "/ltDemand",
      title: "Demand",
      subTitle: "Input",
      icon: shiftnChangeover,
    },
    {
      path: "/facilityMaster",
      title: "Facility Master",
      subTitle: "Input",
      icon: vectorIcon,
    },
    {
      path: "/cascadeMaster",
      title: "Cascade Master",
      subTitle: "Input",
      icon: vectorIcon,
    },
    {
      path: "/rmlandedcost",
      title: "RM Landed Cost",
      subTitle: "Input",
      icon: procurementIcon,
    },
    {
      path: "/rmmilandedCost",
      title: "PMMI Landed Cost",
      subTitle: "Input",
      icon: truckIcon,
    },
    {
      path: "/processingPlant",
      title: "Processing Plant",
      subTitle: "Input",
      icon: processingplantIcon,
    },
    {
      path: "/SFGTransportation",
      title: "SFG Transportation",
      subTitle: "Input",
      icon: truckIcon,
    },
    {
      path: "/packagingPlant",
      title: "Packaging Plant",
      subTitle: "Input",
      icon: packagingplantIcon,
    },
    {
      path: "/primaryTransportation",
      title: "Primary Transportation",
      subTitle: "Input",
      icon: truckIcon,
    },

    {
      path: "/fgBOM",
      title: "FG BOM",
      subTitle: "Input",
      icon: viewIcon,
    },
  ];

  const sideMenuModule3 = [
    {
      path: "/ltDemand",
      title: "Demand",
      subTitle: "Input",
      icon: shiftnChangeover,
    },
    {
      path: "/facilityMaster",
      title: "Facility Master",
      subTitle: "Input",
      icon: vectorIcon,
    },
    {
      path: "/cascadeMaster",
      title: "Cascade Master",
      subTitle: "Input",
      icon: vectorIcon,
    },
    {
      path: "/rmpmprocurement",
      title: "RMPM Procurement",
      subTitle: "Input",
      icon: procurementIcon,
    },
    {
      path: "/rmpmTransportation",
      title: "RMPM Transportation",
      subTitle: "Input",
      icon: truckIcon,
    },

    {
      path: "/packagingPlant",
      title: "Packaging Plant",
      subTitle: "Input",
      icon: packagingplantIcon,
    },
    {
      path: "/primaryTransportation",
      title: "Primary Transportation",
      subTitle: "Input",
      icon: truckIcon,
    },

    {
      path: "/fgBOM",
      title: "FG BOM",
      subTitle: "Input",
      icon: viewIcon,
    },
  ];

  const sideMenuModule4 = [
    {
      path: "/ltDemand",
      title: "Demand",
      subTitle: "Input",
      icon: shiftnChangeover,
    },
    {
      path: "/facilityMaster",
      title: "Facility Master",
      subTitle: "Input",
      icon: vectorIcon,
    },
    {
      path: "/cascadeMaster",
      title: "Cascade Master",
      subTitle: "Input",
      icon: vectorIcon,
    },
    {
      path: "/rmlandedcost",
      title: "RMLanded Cost",
      subTitle: "Input",
      icon: procurementIcon,
    },

    {
      path: "/packagingPlant",
      title: "Packaging Plant",
      subTitle: "Input",
      icon: packagingplantIcon,
    },
    {
      path: "/primaryTransportation",
      title: "Primary Transportation",
      subTitle: "Input",
      icon: truckIcon,
    },
  ];

  const sideMenuModule5 = [
    {
      path: "/ltDemand",
      title: "Demand",
      subTitle: "Input",
      icon: shiftnChangeover,
    },
    {
      path: "/facilityMaster",
      title: "Facility Master",
      subTitle: "Input",
      icon: vectorIcon,
    },
    {
      path: "/cascadeMaster",
      title: "Cascade Master",
      subTitle: "Input",
      icon: vectorIcon,
    },
    {
      path: "/rmpmprocurement",
      title: "RMPM Procurement",
      subTitle: "Input",
      icon: procurementIcon,
    },
    {
      path: "/rmpmTransportation",
      title: "RMPM Transportation",
      subTitle: "Input",
      icon: truckIcon,
    },
    {
      path: "/sfgBOM",
      title: "SFG BOM",
      subTitle: "Input",
      icon: viewIcon,
    },
    {
      path: "/processingPlant",
      title: "Processing Plant",
      subTitle: "Input",
      icon: processingplantIcon,
    },
    {
      path: "/SFGTransportation",
      title: "SFG Transportation",
      subTitle: "Input",
      icon: truckIcon,
    },
    {
      path: "/fgBOM",
      title: "FG BOM",
      subTitle: "Input",
      icon: viewIcon,
    },

    {
      path: "/packagingPlant",
      title: "Packaging Plant",
      subTitle: "Input",
      icon: packagingplantIcon,
    },
    {
      path: "/primaryTransportation",
      title: "Primary Transportation",
      subTitle: "Input",
      icon: truckIcon,
    },
  ];

  const sideMenuModule6 = [
    {
      path: "/ltDemand",
      title: "Demand",
      subTitle: "Input",
      icon: shiftnChangeover,
    },
    {
      path: "/facilityMaster",
      title: "Facility Master",
      subTitle: "Input",
      icon: vectorIcon,
    },
    {
      path: "/cascadeMaster",
      title: "Cascade Master",
      subTitle: "Input",
      icon: vectorIcon,
    },
    {
      path: "/rmlandedcost",
      title: "RMLanded Cost",
      subTitle: "Input",
      icon: procurementIcon,
    },

    {
      path: "/processingPlant",
      title: "Processing Plant",
      subTitle: "Input",
      icon: processingplantIcon,
    },
    {
      path: "/SFGTransportation",
      title: "SFG Transportation",
      subTitle: "Input",
      icon: truckIcon,
    },
    {
      path: "/fgBOM",
      title: "FG BOM",
      subTitle: "Input",
      icon: viewIcon,
    },

    {
      path: "/packagingPlant",
      title: "Packaging Plant",
      subTitle: "Input",
      icon: packagingplantIcon,
    },
    {
      path: "/primaryTransportation",
      title: "Primary Transportation",
      subTitle: "Input",
      icon: truckIcon,
    },
  ];

  const [menuData, setMenuData] = useState<any>(sideMenuData);

  useEffect(() => {
    if (modified_FolderName === "module2") {
      setMenuData(sideMenuModule2);
    } else if (modified_FolderName === "module3") {
      setMenuData(sideMenuModule3);
    } else if (modified_FolderName === "module4") {
      setMenuData(sideMenuModule4);
    } else if (modified_FolderName === "module5") {
      setMenuData(sideMenuModule5);
    } else if (modified_FolderName === "module6") {
      setMenuData(sideMenuModule6);
    } else {
      setMenuData(sideMenuData);
    }
  }, [modified_FolderName]);
  console.log(menuData, "menuData");

  const location: any = useLocation();

  // collabs menu

  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(!open);
  };

  return (
    <div>
      <List>
        <ListItem className="listItem">
          <NavLink
            to="/LongTermHome"
            style={({ isActive }) => (isActive ? isActiveStyle : deActiveStyle)}
            data-toggle="tooltip"
            data-placement="bottom"
            title={"Home"}
          >
            <Grid container spacing={1}>
              <Grid item xs={10} md={10} lg={10}>
                <h4>Home</h4>
                <p>Map View</p>
              </Grid>
              <Grid item xs={2} md={2} lg={2}>
                <img src={HomeIcon} className="image-icon" />
              </Grid>
            </Grid>
          </NavLink>
        </ListItem>
        <ListItem className="listItem">
          <NavLink
            to="/ltCompare"
            style={({ isActive }) => (isActive ? isActiveStyle : deActiveStyle)}
            data-toggle="tooltip"
            data-placement="bottom"
            title={"Compare"}
          >
            <Grid container spacing={1}>
              <Grid item xs={10} md={10} lg={10}>
                <h4>Compare</h4>
                <p>Analysis</p>
              </Grid>
              <Grid item xs={2} md={2} lg={2}>
                <img src={CompareIcon} className="image-icon" />
              </Grid>
            </Grid>
          </NavLink>
        </ListItem>

        <ListItem className="listItem">
          <NavLink
            to="/LongTermflows"
            style={({ isActive }) => (isActive ? isActiveStyle : deActiveStyle)}
            data-toggle="tooltip"
            data-placement="bottom"
            title={"Flows"}
          >
            <Grid container spacing={1}>
              <Grid item xs={10} md={10} lg={10}>
                <h4>Flows</h4>
                <p>Output Preview</p>
              </Grid>
              <Grid item xs={2} md={2} lg={2}>
                <img src={flowsIcon} />
              </Grid>
            </Grid>
          </NavLink>
        </ListItem>
        <ListItem className="listItem">
          <NavLink
            to="/dynamicconstrains"
            style={({ isActive }) => (isActive ? isActiveStyle : deActiveStyle)}
            data-toggle="tooltip"
            data-placement="bottom"
            title={"Dynamic Constraint"}
          >
            <Grid container spacing={1}>
              <Grid item xs={10} md={10} lg={10}>
                <h4>Dynamic Constraint</h4>
                <p>Input</p>
              </Grid>
              <Grid item xs={2} md={2} lg={2}>
                <img src={dynconIcon} />
              </Grid>
            </Grid>
          </NavLink>
        </ListItem>

        <ListItem className="listItem">
          <div style={open ? isActiveStyle : deActiveStyle}>
            <ListItemButton
              onClick={handleClick}
              disabled={
                selectedScenarioId !== 0 && selectedFolderId !== 0
                  ? false
                  : true
              }
            >
              <ListItemText className="listItemtext" primary="Input" />
              {open ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
          </div>
        </ListItem>

        {/* {menuData.map((item: any) => (
          <ListItem className="listItem">
            <NavLink
              to={item?.path}
              style={({ isActive }) =>
                isActive ? isActiveStyle : deActiveStyle
              }
              data-toggle="tooltip"
              data-placement="bottom"
              title={item?.title}
            >
              <Grid container spacing={1}>
                <Grid item xs={10} md={10} lg={10}>
                  <h4>{item?.title}</h4>
                  <p>{item?.subTitle}</p>
                </Grid>
                <Grid item xs={2} md={2} lg={2}>
                  <img src={item?.icon} />
                </Grid>
              </Grid>
            </NavLink>
          </ListItem>
        ))} */}
      </List>
      <div className="list-items-ht">
        <Collapse className="col-long" in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {menuData.map((item: any) => (
              <ListItem className="listItem">
                <NavLink
                  to={item?.path}
                  style={({ isActive }) =>
                    isActive ? isActiveStyle : deActiveStyle
                  }
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title={item?.title}
                >
                  <Grid container spacing={1}>
                    <Grid item xs={10} md={10} lg={10}>
                      <h4>{item?.title}</h4>
                      <p>{item?.subTitle}</p>
                    </Grid>
                    <Grid item xs={2} md={2} lg={2}>
                      <img src={item?.icon} />
                    </Grid>
                  </Grid>
                </NavLink>
              </ListItem>
            ))}
          </List>
        </Collapse>
      </div>
    </div>
  );
}

export default LongTermSidebar;
